import { render, staticRenderFns } from "./xc-personal-infomation-list.vue?vue&type=template&id=6de5a9ac&scoped=true"
import script from "./xc-personal-infomation-list.vue?vue&type=script&lang=js"
export * from "./xc-personal-infomation-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de5a9ac",
  null
  
)

export default component.exports